import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, FormGroup, Label, Form, Row, Col, Card, CardBody, InputGroup, InputGroupText } from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const AddLorry = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Form States
    const [formData, setFormData] = useState({
        lorry_number: "",
        driver_name: "",
        driver_phone: ""
    });

    // Error States for individual field validation
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        const { name, value } = e.target;
        // Keep uppercase for lorry number and remove spaces
        const finalValue = name === "lorry_number" ? value?.toUpperCase().replace(/[^A-Z0-9]/g, '') : value;

        setFormData({ ...formData, [name]: finalValue });

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors({ ...errors, [name]: "" });
        }
    };

    // 🔥 Machan, Inga thaan separate validation logic
    const validateForm = () => {
        let formErrors = {};
        let isValid = true;

        if (!formData.lorry_number.trim()) {
            formErrors.lorry_number = "Lorry number is required";
            isValid = false;
        }

        if (!formData.driver_name.trim()) {
            formErrors.driver_name = "Driver name is required";
            isValid = false;
        }

        if (!formData.driver_phone) {
            formErrors.driver_phone = "Driver phone number is required";
            isValid = false;
        } else if (!/^[0-9]{10}$/.test(formData.driver_phone)) {
            formErrors.driver_phone = "Enter a valid 10-digit mobile number";
            isValid = false;
        }

        setErrors(formErrors);
        return isValid;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // 🔥 Trigger separate validation
        if (!validateForm()) {
            toast.error("Please fill all required fields correctly!");
            return;
        }

        dispatch(loadingTrue());
        try {
            const res = await Handler({
                method: "POST",
                url: "/lorry/create.php",
                data: formData
            });

            if (res?.success) {
                Swal.fire("Success!", "Lorry and Driver registered successfully", "success");
                navigate("/vehicles");
                dispatch(loadingFalse());
            } else {
                if (res?.errors) {
                    setErrors(res.errors);
                } else {
                    toast.error(res?.message || "Failed to register lorry");
                }
                dispatch(loadingFalse());
            }
        } catch (err) {
            Swal.fire("Error", "Server error occurred", "error");
        } finally {
            dispatch(loadingFalse());
        }
    };

    return (
        <div className="page-container p-1">
            <div className="page-header mb-4">
                <h6 className="text-muted">Logistics &gt; Lorries</h6>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h3 className="fw-bold">Register New Lorry</h3>
                        <p className="text-muted">Add lorry details and driver information for transportation.</p>
                    </div>
                    <Button color="secondary" outline onClick={() => navigate(-1)}>
                        <i className="bx bx-arrow-back"></i> Back
                    </Button>
                </div>
            </div>

            <Card className="border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                <CardBody className="p-4">
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={12} className="mb-3">
                                <FormGroup>
                                    <Label className="fw-bold" for="lorry_number">Lorry Number *</Label>
                                    <InputGroup className={errors.lorry_number ? "is-invalid" : ""}>
                                        <InputGroupText className="bg-light"><i className="bx bxs-truck"></i></InputGroupText>
                                        <Input
                                            type="text"
                                            name="lorry_number"
                                            id="lorry_number"
                                            placeholder="e.g. TN33AA1234"
                                            className={errors.lorry_number ? "is-invalid" : ""}
                                            value={formData.lorry_number}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                    {errors.lorry_number && <div className="text-danger small mt-1">{errors.lorry_number}</div>}
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label className="fw-bold" for="driver_name">Driver Name *</Label>
                                    <Input
                                        type="text"
                                        name="driver_name"
                                        id="driver_name"
                                        placeholder="Enter driver's full name"
                                        className={`text-capitalize ${errors.driver_name ? "is-invalid" : ""}`}
                                        value={formData.driver_name}
                                        onChange={handleChange}
                                    />
                                    {errors.driver_name && <div className="invalid-feedback">{errors.driver_name}</div>}
                                </FormGroup>
                            </Col>

                            <Col md={6}>
                                <FormGroup>
                                    <Label className="fw-bold" for="driver_phone">Driver Phone Number *</Label>
                                    <InputGroup className={errors.driver_phone ? "is-invalid" : ""}>
                                        <InputGroupText><i className="bx bx-phone"></i></InputGroupText>
                                        <Input
                                            type="text"
                                            name="driver_phone"
                                            id="driver_phone"
                                            placeholder="10 digit mobile number"
                                            maxLength="10"
                                            className={errors.driver_phone ? "is-invalid" : ""}
                                            value={formData.driver_phone}
                                            onChange={handleChange}
                                        />
                                    </InputGroup>
                                    {errors.driver_phone && <div className="text-danger small mt-1">{errors.driver_phone}</div>}
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="mt-4 pt-3 border-top d-flex justify-content-end">
                            <Button type="button" color="light" className="me-2" onClick={() => navigate(-1)}>
                                Cancel
                            </Button>
                            <Button type="submit" className="add-btn px-5">
                                <i className="bx bx-plus-circle me-1"></i> Register Lorry
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </div>
    );
};

export default AddLorry;